import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { gettotalOffers } from "../../store/totaloffer/totaloffAction";
import { Link } from "react-router-dom";
import { baseUrl } from "../../utils/APi";
import { LazyLoadImage } from "react-lazy-load-image-component";
import img1 from "../../assets/partner1.png";
import img2 from "../../assets/partner2.png";
import img3 from "../../assets/partner3.jpg";
import img4 from "../../assets/partner4.png";
import img5 from "../../assets/partner5.png";
import img6 from "../../assets/partner6.png";
import img7 from "../../assets/partner7.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation} from "swiper/modules";
const Clients = () => {
  // const dispatch = useDispatch();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { offers } = useSelector((state) => state.Offers);

  // useEffect(() => {
  //   if (offers?.length === 0 ) {
  //    const promise= dispatch(gettotalOffers(lan));
  //     return () => {
  //       promise.abort();
  //     };
  //   }
  // }, [lan, dispatch,offers?.length]);

  const partners = [
    img2,img3,img5,
    img6,img7,img1,img2,
    img3,img4,img5,img6,img1,
    img7,img1,img2,img3,
  ];

  return (
    <section className="section-wrap partners pt-0 pb-50">
      <div className="container">
        <div className="row">
          <Swiper
            spaceBetween={10}           
            slidesPerView={4}
                 
            loop={true}                  
            autoplay={{ delay: 3000 }}   
           
        
          >
            {partners.map((partner, index) => (
              <SwiperSlide key={index} className="item">
                  <img src={partner} alt={`Partner ${index + 1}`} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Clients;
